// extracted by mini-css-extract-plugin
module.exports = {"InCreationOutput":"JobDetailInputOutput_InCreationOutput__1qNrC","InCreationOutputText":"JobDetailInputOutput_InCreationOutputText__pkVR7"};